import React from 'react';
import { ManageCaseOption } from '@components/CaseDetails/ManageCaseDropDown/ManageCaseOption';
import { useCopyCaseState } from '@components/CaseDetails/CopyCaseContext/CopyCaseContext';
import { useSelector } from 'react-redux';
import { CaseDetailsIsAttachmentType, CaseDetailsInfoSelector } from '@store/selectors/CaseDetailsSelector';
import { RenderAsProps } from '@components/CaseDetails/ManageCaseDropDown/DropDownOptions/DropDownOptionProps';
import { useCollectionEntity } from '@utilities/hooks/useCollectionEntity/useCollectionEntity';
import { ENDPOINT_USER_UNITS } from '@utilities/apiConstants';
import { Unit } from '@data/unit/Unit';

export const CopyCaseOption = ({ closeDropdown }: RenderAsProps) => {
	const { openModal } = useCopyCaseState();
	const hideOption = useSelector(CaseDetailsIsAttachmentType);
	const { unit } = useSelector(CaseDetailsInfoSelector);
	const unitDetails = useCollectionEntity<Unit>(ENDPOINT_USER_UNITS, unit, 'id') as Unit;
	const unitHasSchedulingDisabled = Boolean(unitDetails?.disableScheduling);

	const handleOpenCopyModal = () => {
		openModal();
		closeDropdown();
	};

	if (hideOption || unitHasSchedulingDisabled) {
		return null;
	}

	return <ManageCaseOption onClick={handleOpenCopyModal} fieldName="copyCase">Copy</ManageCaseOption>;
};
